export default __webpack_public_path__ + "static/media/main_BG.817bc44d.png";